"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const sharedUtils_1 = require("src/utils/sharedUtils");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const useLocalStorage_1 = require("src/hooks/useLocalStorage");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const selectors_1 = require("src/stores/applicationStore/auth/selectors");
const thunk_1 = require("src/stores/applicationStore/auth/thunk");
const CutsomBtn_1 = __importDefault(require("src/components/molecules/CutsomBtn"));
const AvatarButton_module_css_1 = __importDefault(require("./styles/AvatarButton.module.css"));
const AvatarButton = ({ isFloat = false }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const initials = (0, sharedUtils_1.getInitials)(me.first_name, me.last_name);
    const navigate = (0, react_router_dom_1.useNavigate)();
    let timer = null;
    const clearTimer = () => {
        setShow(true);
        clearTimeout(timer);
        timer = null;
    };
    const setTimer = () => {
        timer = setTimeout(() => {
            setShow(false);
        }, 500);
    };
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        yield dispatch((0, thunk_1.logoutThunk)());
    });
    const editSettings = () => {
        navigate("/user/edit");
    };
    const changeLang = () => {
        const lang = (0, useLocalStorage_1.useLocalStorage)("language");
        const newLang = lang == "ru" ? "en" : "ru";
        (0, useLocalStorage_1.useLocalStorage)("language", newLang);
        window.location.reload();
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: isFloat ? "to-flex-right" : null }, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, Object.assign({ placement: "bottom", show: show, overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover, Object.assign({ id: `avatar-popover`, onMouseOver: () => clearTimer(), onMouseOut: () => setTimer() }, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Popover.Body, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "profile-data" }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [me.first_name, " ", me.last_name] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text-muted mt-1" }, { children: me.email }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `d-flex flex-column ${AvatarButton_module_css_1.default.control}` }, { children: [(0, jsx_runtime_1.jsx)(CutsomBtn_1.default, { onClick: changeLang, label: i18n_1.default.t("ChangeLanguage") }), (0, jsx_runtime_1.jsx)(CutsomBtn_1.default, { onClick: editSettings, label: i18n_1.default.t("edit profile") }), (0, jsx_runtime_1.jsx)(CutsomBtn_1.default, { onClick: () => logout(), label: i18n_1.default.t("Logout") })] }))] }) })) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `avatar transition-ease ${show ? "avatar__hovered" : ""}`, onMouseEnter: () => clearTimer(), onMouseLeave: () => setTimer() }, { children: !show && (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { pointerEvents: "none" } }, { children: initials })) })) })) })));
};
exports.default = AvatarButton;
